export const CART_NEWRELIC_BROWSER_AGENT_IDENTIFIER = 'cartBrowserAgent';

const NEW_RELIC_LICENSE_KEY = process.env.NR_LICENSE_KEY;
const NEW_RELIC_APP_ID = process.env.NR_APP_ID;

export const NEW_RELIC_CONFIG = {
  init: {
    privacy: { cookies_enabled: true },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: '2429158',
    trustKey: '1106546',
    agentID: `${NEW_RELIC_APP_ID}`,
    licenseKey: `${NEW_RELIC_LICENSE_KEY}`,
    applicationID: `${NEW_RELIC_APP_ID}`,
  }, // NREUM.loader_config
};
